/**
 *
 * RecordProcesses
 *
 */

import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectReducer from "utils/injectReducer"
import injectSaga from "utils/injectSaga"
import moment from "moment"
import { map, truncate, debounce, filter } from "lodash"
import { Input, Tooltip } from "antd"
import Loader from "components/Loader"
import reducer from "./reducer"
import saga from "./saga"
import { getProcessHistoryWatcher } from "./actions"
import {
  makeSelectProcessHistories,
  makeSelectIsLoadingProcessHistories,
} from "./selectors"

import imageEmpty from "../../../images/empty-state-control-panel.svg"

import "./index.less"
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons"

/* eslint-disable react/prefer-stateless-function */
export class RecordProcesses extends React.Component {
  state = {
    stateProcess: this.props.processHistories,
    searchfilter: "",
    /* mainSearchValue: "", */
    filteredData: this.props.processHistories
  }
  componentDidUpdate(prevProps) {
    if (prevProps.processHistories && !this.props.processHistories) {
      this.setState({
        stateProcess: this.props.processHistories
      });
    }
  }
  componentDidMount = () => {
    this.props.getProcessHistoryWatcher()
    this.setState({
      stateProcess: this.props.processHistories,
    })

  }
  validTextLength = (text) => {
    if (text.length > 60) {
      text = text.slice(0, 60) + "...";
    }
    return text;
  }

  handleSearchChange = (value) => {
    this.setState({
      searchfilter: value,
      stateProcess: filter(this.props.processHistories, (item) => {
        return (
          item.company.toLowerCase().includes(this.state.searchfilter.toLowerCase()) ||
          item.user.toLowerCase().includes(this.state.searchfilter.toLowerCase())
        )
      }),
    })
  }

  render() {
    const { processHistories, isLoadingProcessHistories } = this.props

    return (
      <div className="container-record-processes">
        <p className="container-record-processes__description">
          A continuación, se detalla el historial de los procesos de soporte en la plataforma.
        </p>

        {typeof isLoadingProcessHistories === "undefined" ? (
          <Loader height="80vh" />
        ) : !processHistories.length ? (
          <div className="container-record-processes__empty">
            <img src={imageEmpty} />
            <p>Aún no cuentas con un historial para mostrar.</p>
          </div>
        ) : (
          <Fragment>
            <div className="rPFilters">
              <Input
                value={this.state.searchfilter}
                onChange={(e) => this.handleSearchChange(e.target.value)}
                placeholder="Buscar empresa o usuario..."
                suffix={
                  this.state.searchfilter ? (
                    <CloseCircleOutlined
                      style={{
                        cursor: "pointer",
                        color: "white",
                        background: "rgba(0, 0, 0, 0.25)",
                        borderRadius: "50%",
                      }}
                      onClick={() => this.handleSearchChange("")}
                    />
                  ) : (
                    <SearchOutlined />
                  )
                }
                style={{ width: 280, marginLeft: "1rem" }}
              />
            </div>
            <div className="container-record-processes__records">
              <div className="container-record-processes__header">
                <div className="column-wide">Empresa</div>
                <div className="column-wide ">Medición</div>
                <div className="column-wide">Proceso</div>
                <div className="column-wide">Fecha</div>
                <div className="column-wide">Hora</div>
                <div className="column-wide">Usuario</div>
                <div className="column-wide">Browser/IOS</div>
                <div className="column-wide">IP</div>
              </div>
              {map(
                this.state.searchfilter ? this.state.stateProcess : processHistories,
                ({
                  id_record_support,
                  company,
                  measure,
                  action,
                  date,
                  user,
                  user_agent,
                  ip_address
                }) => {
                  return (
                    <div className="container-record-processes__body color-black" key={id_record_support}>
                      <div className="two-line-text column-wide">
                        {truncate(company, { length: 63, separator: "..." })}
                      </div>
                      <div className="two-line-text column-wide">
                        {this.validTextLength(measure)}
                      </div>
                      <div className="column-wide">
                        {action === 1 ? "Desoficialización" : "Reprocesamiento"}
                      </div>
                      <div className="column-wide">
                        {moment(new Date(date)).format("DD/MM/YYYY")}
                      </div>
                      <div className="column-wide">
                        {moment(new Date(date)).format("HH:mm")}
                      </div>
                      <div className="two-line-text column-wide">
                        {this.validTextLength(user)}
                      </div>

                      <div className="two-line-text column-wide">
                      {truncate(user_agent, { length: 63, separator: "..." })}
                      </div>

                      <div className="two-line-text column-wide">{ip_address}</div>
                    </div>
                  )
                }
              )}
            </div>
          </Fragment>
        )}
      </div>
    )
  }
}

RecordProcesses.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  processHistories: makeSelectProcessHistories(),
  isLoadingProcessHistories: makeSelectIsLoadingProcessHistories(),
})

function mapDispatchToProps(dispatch) {
  return {
    getProcessHistoryWatcher: () => dispatch(getProcessHistoryWatcher())
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "recordProcesses", reducer })
const withSaga = injectSaga({ key: "recordProcesses", saga })

export default compose(withReducer, withSaga, withConnect)(RecordProcesses)
